import { render, staticRenderFns } from "./AlarmPointFinder.vue?vue&type=template&id=54a8b1ba&scoped=true"
import script from "./AlarmPointFinder.vue?vue&type=script&lang=ts"
export * from "./AlarmPointFinder.vue?vue&type=script&lang=ts"
import style0 from "./AlarmPointFinder.vue?vue&type=style&index=0&id=54a8b1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8b1ba",
  null
  
)

export default component.exports